import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ProductService } from '../../../../../../admin/src/app/services/product.service';
import { Product } from '../../../../../../admin/src/app/models/product';
import { Subscription } from "rxjs";
import { ZendeskService } from "../../../services/zendesk.service";
import { ZendeskPageSearchResult, ZendeskSearchResult } from "../../../models/zendesk-search-result";
import { LanguageService } from "../../../services/language.service";
import { MatomoTracker } from "ngx-matomo";

@Component({
  selector: 'app-product-kb',
  templateUrl: './product-kb.component.html',
  styleUrls: ['./product-kb.component.css']
})
export class ProductKBComponent implements OnInit, OnDestroy {

  productId: string;

  product: Product;

  sub: Subscription;

  zendeskResults: ZendeskSearchResult[] = [];

  zendeskError = false;

  constructor(
    private route: ActivatedRoute,
    private productSvc: ProductService,
    private zendeskSvc: ZendeskService,
    public language: LanguageService,
    private matomoTracker: MatomoTracker
  ) { }

  ngOnInit() {
    this.matomoTracker.trackPageView('Product KB');

    this.sub = this.route.parent.paramMap.subscribe(params => {
      this.productId = params.get('productId');
      this.getProduct();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getProduct() {
    this.productSvc.get(this.productId).subscribe(data => {
      this.product = data.payload;
      this.getArticles();
    });
  }

  getArticles() {
    this.zendeskSvc.search(this.product.name).subscribe(page => {
      this.zendeskError = false;
      if ((page as ZendeskPageSearchResult).results !== undefined) {
        this.zendeskResults = (page as ZendeskPageSearchResult).results;
      }
    }, _ => {
      this.zendeskError = true;
    });
  }
}
